<template>
  <div class="pc">
    <div class="pc-box">
      <div class="sys-entry-content">
        <div class="arrow-prev" @click="handlePrev" v-show="showArrow">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="arrow-next" @click="handleNext" v-show="showArrow">
          <i class="el-icon-arrow-right"></i>
        </div>
        <el-carousel indicator-position="none" :autoplay="false" arrow="never" ref="carousel">
          <el-carousel-item v-for="(item, index) in menusList" :key="index">
            <el-row :gutter="20">
              <el-col :span="8" v-for="menu in item" :key="menu.id">
                <div class="entry-box">
                  <div class="entry-box-item" @click="handleClick(menu)">
                    <div class="icon-div">
                      <img class="icon" src="../assets/img/projectImg.png" />
                    </div>
                    <div class="sys-title-content">
                      <span class="sys-title">{{menu.orgName}}</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { setSession, getSession } from '@/untils';
import { getNameByPublicDomain, queryIndex } from '../api/publicinquiry.api.js';
import { isUndef } from '@/untils/index';
export default {
  computed: {
    showArrow() {
      if (this.fullHeight <= 960) {
        return this.newMenusList.length > 9;
      } else {
        return this.newMenusList.length > 15;
      }
    }
  },
  data() {
    return {
      menusList: [],
      newMenusList: [],
      orgId: '',
      showName: '',
      fullHeight: document.documentElement.clientHeight
    };
  },
  methods: {
    handlePrev() {
      this.$refs.carousel.prev();
    },
    handleNext() {
      this.$refs.carousel.next();
    },
    handleClick(item) {
      setSession('orgId', item.id);
      setSession('orgName', item.orgName);
      setSession('isShow', 2);
      this.$router.push({
        name: 'projectlist'
      });
    },
    getNameByPublicDomain() {
      const domain = location.host;
      let params = {
        domain
      };
      getNameByPublicDomain(params).then(res => {
        if (res) {
          setSession('showName', res.body.showName);
          setSession('isSmsVerify', res.body.isSmsVerify);
          setSession('houseType', res.body.houseType);
          setSession('personalSwitch', res.body.personalSwitch);
          this.$store.commit('setShowName', res.body.showName);
          document.title = !isUndef(getSession('showName'))
            ? getSession('showName')
            : '房屋征收信息公开系统';
          if (res.body.orgLevel === 3) {
            setSession('orgId', res.body.orgId);
            setSession('isShow', 1);
            this.$router.push({
              name: 'projectlist'
            });
          } else {
            this.orgId = res.body.orgId;
            let params = {
              orgId: this.orgId
            };
            setSession('orgId', res.body.orgId);
            queryIndex(params).then(res => {
              var newArr = [];
              if (res.body) {
                this.newMenusList = res.body;
                if (this.fullHeight <= 960) {
                  for (let i = 0; i < res.body.length; i += 9) {
                    newArr.push(res.body.slice(i, i + 9));
                  }
                } else {
                  for (let i = 0; i < res.body.length; i += 15) {
                    newArr.push(res.body.slice(i, i + 15));
                  }
                }
              }
              this.menusList = newArr;
              if (this.menusList[0] && this.menusList[0].length === 1) {
                setSession('orgId', this.menusList[0][0].id);
                setSession('isShow', 1);
                this.$router.push({
                  name: 'projectlist'
                });
              }
            });
          }
        }
      });
    },
    handleResize(event) {
      this.fullHeight = document.documentElement.clientHeight;
    }
  },
  created() {
    this.getNameByPublicDomain();
  },
  ready() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.sys-title-content {
  position: relative;
  width: calc(~"100% - 70px");
  height: 80px;
}
.sys-title {
  position: absolute;
  line-height: 35px;
  top: 50%;
  transform: translateY(-50%);
}
.pc {
  height: 100%;
  position: relative;
}
.pc-box {
  /* margin: auto;
  width: 1200px; */
  background: #ffffff;
}
.sys-entry-content {
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.entry-box {
  margin-top: 20px;
  padding: 2px 2px;
  background: url("~@/assets/img/bg.png") no-repeat center;
  background-size: 100% 100%;
  width: 280px;
  height: 80px;
  margin: 10px auto;
  /* background: radial-gradient(circle at center center, #ffffff, #ffffff),
    linear-gradient(#025b91, #025b91) left top,
    linear-gradient(#025b91, #025b91) left top,
    linear-gradient(#025b91, #025b91) right top,
    linear-gradient(#025b91, #025b91) right top,
    linear-gradient(#025b91, #025b91) left bottom,
    linear-gradient(#025b91, #025b91) left bottom,
    linear-gradient(#025b91, #025b91) right bottom,
    linear-gradient(#025b91, #025b91) right bottom,
    linear-gradient(#ffffff, #ffffff) top,
    linear-gradient(#ffffff, #ffffff) bottom,
    linear-gradient(#ffffff, #ffffff) left,
    linear-gradient(#ffffff, #ffffff) right;
  background-repeat: no-repeat;
  background-position: 2px 2px, 0px 0px, 0px 0px, 0px 100%, 0px 100%, 100% 0px,
    100% 0px, 100% 100%, 100% 100%, 0px 0px, 0px 100%, 0px 100%, 100% 100%;
  background-size: calc(100% - 4px) calc(100% - 4px), 5px 20px, 20px 5px,
    5px 20px, 20px 5px, 5px 20px, 20px 5px, 5px 20px, 20px 5px, 100% 5px,
    100% 5px, 5px 100%, 5px 100%; */
}
.entry-box-item {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  line-height: 80px;
}
.entry-box-item:hover {
  background-color: rgb(224, 245, 255);
}
.arrow-prev {
  left: -100px;
}
.arrow-next {
  right: -100px;
}
.arrow-prev,
.arrow-next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
i {
  font-size: 60px;
  color: #025b91;
}
.icon-div img {
  width: 48px;
}
.icon-div {
  padding: 20px 10px;
}
</style>
<style media="screen">
/*分辨率低于1440，采用下面的样式*/
@media screen and (max-device-width: 1440px) {
  .sys-entry-content {
    width: 880px;
  }
  .el-carousel__container {
    height: 600px !important;
  }
}
/*分辨率高于1440，采用下面的样式*/
@media screen and (min-device-width: 1440px) {
  /* .entry-box {
    width: 280px;
    height: 60px;
  } */
  .el-carousel__container {
    height: 550px !important;
  }
}
/*分辨率高于1440，采用下面的样式*/
@media screen and (min-device-width: 1600px) {
  /* .entry-box {
    width: 280px;
    height: 85px;
  } */
  .el-carousel__container {
    height: 550px !important;
  }
  /* .pc-box {
    height: 700px !important;
  } */
}
/*分辨率低于1440，采用下面的样式*/
@media screen and (max-device-height: 900px) {
  /* .pc-box {
    height: 700px !important;
  } */
  .el-carousel__container {
    height: 400px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/house-expropriation.vue